import {
    ALGOLIA_APP_ID,
    ALGOLIA_SEARCH_KEY,
    ALGOLIA_INDEX_BY_TIMESTAMP
} from "../search/constants";

import algoliasearch from "algoliasearch/lite";
import AnnouncementsCardStyle from "../AnnouncementsCardStyle";

export default class AlgoliaFeedNewsAnnouncements {
    static create(el) {
        new AlgoliaFeedNewsAnnouncements(el);
    }

    constructor(el) {
        this.el = el;
        this.clientId = ALGOLIA_APP_ID;
        this.apiKey = ALGOLIA_SEARCH_KEY;
        this.indexName = window.search_index_timestamp || ALGOLIA_INDEX_BY_TIMESTAMP;
        this.announcementCardStyles = new AnnouncementsCardStyle();

        this.BREAKPOINTS = {
            768: 5,
            1280: 4,
        };

        this.currentBreakpoint = this.getCurrentBreakpoint();

        this.init();
    }

    getCurrentBreakpoint() {
        const width = window.innerWidth;
        let currentBreakpoint = { size: null, items: 9 };

        for (const breakpoint in this.BREAKPOINTS) {
            if (width < breakpoint) {
                currentBreakpoint = { size: breakpoint, items: this.BREAKPOINTS[breakpoint] };
                break;
            }
        }

        return currentBreakpoint;
    }

    init() {
        this.containerEl = this.el.querySelector(".recent-announcements-list");
        this.loadMoreBtn = this.el.querySelector(".load-more-announcements");
        this.loadMoreWrapper = this.el.querySelector(".recent-announcements--button-wrapper");
        this.spinner = this.el.querySelector(".spinner");
        this.postsHit = this.currentBreakpoint.items - 1;
        this.postsHitMore = this.currentBreakpoint.items;
        this.currentPage = 0;
        this.isLoading = false;
        this.loadedPosts = 0;

        this.client = algoliasearch(this.clientId, this.apiKey);
        this.index = this.client.initIndex(this.indexName);

        this.loadPosts();
        this.loadMoreButton();
    }

    loadPosts() {
        this.isLoading = true;
        this.spinner.style.display = 'block';

        const perPage = this.currentPage === 0 ? this.postsHit : this.postsHitMore;
        const offset = this.currentPage === 0 ? 0 : this.postsHit + (this.currentPage - 1) * this.postsHitMore;

        const options = {
            offset: offset,
            length: perPage,
            facets: [ 'is_hidden', 'type', 'has_password', 'hide_from_news_latest'],
            facetFilters: [
                `is_hidden:false`,
                `has_password:false`,
                `hide_from_news_latest:false`,
                `type:Company Announcement`,
            ]
        };

        this.index.search('', options).then(({ hits, nbPages, nbHits, offset, length }) => {
            if (hits.length === 0) {
                if (this.currentPage === 0) {
                    this.containerEl.style.display = 'none';
                }
                this.loadMoreBtn.parentElement.style.display = 'none';
            } else {
                hits.forEach(hit => {
                    const newElement = document.createElement('li');
                    newElement.innerHTML = this.renderPost(hit);
                    this.loadMoreWrapper.parentNode.insertBefore(newElement, this.loadMoreWrapper);
                });
                this.inlineSVG();
                this.loadedPosts += hits.length;
                this.loadMoreBtn.style.display = this.loadedPosts < nbHits ? 'block' : 'none';
                this.currentPage += 1;
            }
            this.isLoading = false;
            this.spinner.removeAttribute('style');
        }).catch(err => {
            console.error(err);
            this.isLoading = false;
            this.spinner.removeAttribute('style');
        });
    }

    inlineSVG(){
        const images = this.containerEl.querySelectorAll('[data-pattern]');
        images.forEach((image) => {
            const img = image.getAttribute('data-pattern');
            fetch(img)
                .then(response => response.text())
                .then(svg => {
                    image.innerHTML = svg;
                    image.removeAttribute('data-pattern');
                });
        });
    }

    renderPost(item){
        const link = item.url || '';
        const cardStyle = this.announcementCardStyles.getNextCardStyle();
        const className = cardStyle.class || '';
        const pattern = cardStyle.patternURL || '';
        const logo = item.company_logo_url || '';
        const vertical = item.verticals || '';
        const title = item.title || '';
        const authorName = item.author || '';
        return `
            <a href="${link}" target="_blank" rel="noopener noreferrer">
                <div class="card ${className} p1">
                    <div class="wrap">
                        <div class="pattern" data-pattern="${pattern}">
                        </div>
                        ${logo ? '<div class="logo"><img src="' + logo + '" alt="' + title + '"></div>' : ''}
                    </div>
                </div>

                <strong>${vertical}</strong>
                <h6>${title}</h6>
                <span>${authorName}</span>
            </a>
        `
    }

    loadMoreButton() {
        this.loadMoreBtn.onclick = (e) => {
            e.preventDefault();
            if(this.isLoading) return;
            this.loadPosts();
        };
    }
}
